import { Inject, Injectable, Injector }from '@angular/core';


import { Reports_custom_ds_inventory_reportService } from './Reports.datasource.index';
import { Reports_custom_ds_inventory_report_flowService } from './Reports.datasource.index';
import { Reports_custom_ds_inventory_with_allocations_reportService } from './Reports.datasource.index';
import { Reports_custom_ds_inventory_with_allocations_report_get_inventory_by_lotService } from './Reports.datasource.index';
import { Reports_custom_ds_placard_address_reportService } from './Reports.datasource.index';
import { Reports_custom_ds_placard_order_reportService } from './Reports.datasource.index';
import { Reports_custom_ds_placard_reportService } from './Reports.datasource.index';
import { Reports_custom_ds_placard_tasks_reportService } from './Reports.datasource.index';

@Injectable({ providedIn: 'root' })
export class Reports_DatasourceService {

  constructor(
    private injector: Injector
  ) {
  }

  public Reports: Reports_DatasourceService = this;

  // injecting lazily in order to avoid circular dependencies
  private _custom_ds_inventory_report: Reports_custom_ds_inventory_reportService;
  public get custom_ds_inventory_report(): Reports_custom_ds_inventory_reportService {
    if(!this._custom_ds_inventory_report) {
      this._custom_ds_inventory_report = this.injector.get(Reports_custom_ds_inventory_reportService);
    }
    return this._custom_ds_inventory_report;
  }
  private _custom_ds_inventory_report_flow: Reports_custom_ds_inventory_report_flowService;
  public get custom_ds_inventory_report_flow(): Reports_custom_ds_inventory_report_flowService {
    if(!this._custom_ds_inventory_report_flow) {
      this._custom_ds_inventory_report_flow = this.injector.get(Reports_custom_ds_inventory_report_flowService);
    }
    return this._custom_ds_inventory_report_flow;
  }
  private _custom_ds_inventory_with_allocations_report: Reports_custom_ds_inventory_with_allocations_reportService;
  public get custom_ds_inventory_with_allocations_report(): Reports_custom_ds_inventory_with_allocations_reportService {
    if(!this._custom_ds_inventory_with_allocations_report) {
      this._custom_ds_inventory_with_allocations_report = this.injector.get(Reports_custom_ds_inventory_with_allocations_reportService);
    }
    return this._custom_ds_inventory_with_allocations_report;
  }
  private _custom_ds_inventory_with_allocations_report_get_inventory_by_lot: Reports_custom_ds_inventory_with_allocations_report_get_inventory_by_lotService;
  public get custom_ds_inventory_with_allocations_report_get_inventory_by_lot(): Reports_custom_ds_inventory_with_allocations_report_get_inventory_by_lotService {
    if(!this._custom_ds_inventory_with_allocations_report_get_inventory_by_lot) {
      this._custom_ds_inventory_with_allocations_report_get_inventory_by_lot = this.injector.get(Reports_custom_ds_inventory_with_allocations_report_get_inventory_by_lotService);
    }
    return this._custom_ds_inventory_with_allocations_report_get_inventory_by_lot;
  }
  private _custom_ds_placard_address_report: Reports_custom_ds_placard_address_reportService;
  public get custom_ds_placard_address_report(): Reports_custom_ds_placard_address_reportService {
    if(!this._custom_ds_placard_address_report) {
      this._custom_ds_placard_address_report = this.injector.get(Reports_custom_ds_placard_address_reportService);
    }
    return this._custom_ds_placard_address_report;
  }
  private _custom_ds_placard_order_report: Reports_custom_ds_placard_order_reportService;
  public get custom_ds_placard_order_report(): Reports_custom_ds_placard_order_reportService {
    if(!this._custom_ds_placard_order_report) {
      this._custom_ds_placard_order_report = this.injector.get(Reports_custom_ds_placard_order_reportService);
    }
    return this._custom_ds_placard_order_report;
  }
  private _custom_ds_placard_report: Reports_custom_ds_placard_reportService;
  public get custom_ds_placard_report(): Reports_custom_ds_placard_reportService {
    if(!this._custom_ds_placard_report) {
      this._custom_ds_placard_report = this.injector.get(Reports_custom_ds_placard_reportService);
    }
    return this._custom_ds_placard_report;
  }
  private _custom_ds_placard_tasks_report: Reports_custom_ds_placard_tasks_reportService;
  public get custom_ds_placard_tasks_report(): Reports_custom_ds_placard_tasks_reportService {
    if(!this._custom_ds_placard_tasks_report) {
      this._custom_ds_placard_tasks_report = this.injector.get(Reports_custom_ds_placard_tasks_reportService);
    }
    return this._custom_ds_placard_tasks_report;
  }
}

